<app-fordjupning-karta-base [layerConfig]="layerConfig$ | async" (mapClicked)="onMapClicked($event)">
    <app-fordjupning-karta-popup [isLoading]="isLoadingPopupData" [popupContent]="popupData$ | async">
        <ng-container *ngIf="(popupData$ | async)?.thumbsUp; else elseTemplate" popupIcon>
            <span class="abinicon-arsskada_tall_uppfyllt" role="img" aria-label="Målet är uppnått"></span>
        </ng-container>
        <ng-template #elseTemplate popupIcon>
            <span class="abinicon-arsskada_tall_ej_uppfyllt" role="img" aria-label="Målet är inte uppnått"></span>
        </ng-template>
    </app-fordjupning-karta-popup>
</app-fordjupning-karta-base>
<br />
<ui-figure-caption>
    <ui-figure-text ui-figure-text-bold>
        Skalan i kartan visar måluppfyllelse samt skadenivå. För de flesta områden är gränserna 5 % för Tolerabel skada, 5-10 % för Allvarlig skada, 10-20 % för
        Svår skada och högre än 20 % för Mycket svår skada. På svagare marker är gränserna dock lägre med 2 % för Tolerabel skada, 2-5 % för Allvarlig skada,
        5-10 % för Svår skada och högre än 10 % för Mycket svår skada.
    </ui-figure-text>
</ui-figure-caption>
